import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import EventsCarousel from "./component/EventsCarousel";
import RootCause from "./component/RootCause";
import PreventiveAction from "./component/PreventiveAction";
import html2pdf from "html2pdf.js";
import { API_URL } from "configs";
import {
  redirectToIncidentList,
  generateFinalReportForIncident,
} from "actions";
import Resolution from "./component/Resolution/Resolution";
import ConfirmationModal from "./component/ConfirmationModal";

const FinalReportTab = ({ previousData, incidentId, onNext, onBack }) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const incidentState = useSelector((state) => state.incidentState);
  const reportRef = useRef(null);

  const [isFinalReportGenerated, setIsFinalReportGenerated] = useState(false);
  const [isPreviewReport, setIsPreviewReport] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [severityImg, setSeverityImg] = useState(
    "/assets/images/file-icon.svg"
  );

  console.log("Previous Data in FinalReportTab:", previousData);

  useEffect(() => {
    if (previousData?.status === "final_report") {
      setIsFinalReportGenerated(true);
    }
    if (previousData?.status === "preview_report") {
      setIsPreviewReport(true);
    }

    const img =
      previousData?.severity_level_relation?.file_path ||
      "/assets/images/file-icon.svg";
    setSeverityImg(img);
  }, [previousData]);

  const generateFinalReport = () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    dispatch(
      generateFinalReportForIncident(
        incidentId,
        session.current_page_permissions.object_id,
        userTimezone
      )
    ).then(() => {
      setIsFinalReportGenerated(true);
      setIsPreviewReport(false);
    });
    setShowConfirmationModal(false);
  };

  const downloadPDF = () => {
    const element = reportRef.current;
    if (!element) return;

    const options = {
      margin: 0.5,
      filename: "Final_Report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(element).set(options).save();
  };

  const downloadPDFReport = (e, record_id) => {
    const token = localStorage.getItem("token");
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('userTimezone', userTimezone)
    window.location.href =
      API_URL +
      "incident/downloadPDFReport?id=" +
      record_id +
      "&token=" +
      token +
      "&timezone=" +
      userTimezone;
  };

  return (
    <>
      <div className="final-report-content" ref={reportRef}>
        {/* Report Header */}
        <div className="final-report-content mb-3">
          <h2 className="font-18 font-weight-bold heading-color mb-2">
            {previousData.incident_name || ""}
          </h2>
          <Row>
            <Col lg={4}>
              <div>
                <h2 className="font-13 font-weight-bold heading-color">
                  Severity:
                </h2>
                <p className="font-13 font-weight-normal text-color">
                  <img
                    src={severityImg}
                    className="me-2"
                    alt={previousData.severity_level_name || "Severity"}
                    style={{ width: 16, height: 16 }}
                  />
                  {previousData.severity_level_name || ""}
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <div>
                <h2 className="font-13 font-weight-bold heading-color mb-2">
                  Scope:
                </h2>
                <p className="font-13 font-weight-normal text-color mb-1">
                  {(previousData.scopes || [])
                    .map((scope) => scope.opt_display ?? scope.name)
                    .join(", ")}
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <div>
                <h2 className="font-13 font-weight-bold heading-color">
                  Description:
                </h2>
                <p
                  className="font-13 font-weight-normal text-color"
                  dangerouslySetInnerHTML={{
                    __html:
                      previousData.initiation_description ||
                      "<i>No description</i>",
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div className="final-report-content mb-3">
          <EventsCarousel previousData={previousData} />
        </div>

        <div>
          <Resolution resolutions={previousData?.resolutions} />
        </div>
        <div>
          <RootCause rootCauses={previousData?.root_causes} />
        </div>
        <div>
          <PreventiveAction
            prevention_actions={previousData?.prevention_actions}
          />
        </div>
      </div>

      <div className="d-flex justify-content-start gap-3 m-3">
        {/* Back Button */}
        {isFinalReportGenerated ? (
          <button
            className="c-b-btn"
            onClick={() => dispatch(redirectToIncidentList())}
          >
            Back To List
          </button>
        ) : (
          <button className="c-b-btn" onClick={onBack}>
            <img className="me-2" src="/assets/images/back-arrow.svg" alt="" />
            Back
          </button>
        )}

        {/* Conditional Action Button */}
        {isPreviewReport && (
          <button
            className="n-u-btn"
            onClick={() => setShowConfirmationModal(true)}
          >
            Generate Final Report
          </button>
        )}

        {isFinalReportGenerated && (
          <button
            className="n-u-btn"
            onClick={(e) => downloadPDFReport(e, incidentId)}
          >
            Download PDF
          </button>
        )}
      </div>

      {/* Confirmation Modal */}
      <ConfirmationModal
        show={showConfirmationModal}
        handleClose={() => setShowConfirmationModal(false)}
        handleConfirm={generateFinalReport}
        title="Generate Final Report"
        message="Are you sure you want to generate the final report? This action cannot be undone."
      />
    </>
  );
};

export default FinalReportTab;
